module.exports = __webpack_public_path__ + "img/03-9.bfdf54c2.png";